import { COLOR_BRAND_BLUE_40, COLOR_NEUTRAL_50, IconAward, IconBarChart, IconMoney, IconPlane } from '@consumidor-positivo/aurora';
import { OrderByFilter } from '../../../types';

type OrderByItem = {
  slug: OrderByFilter;
  label: string;
  showOnBenefit?: string;
  icon: (active: boolean) => JSX.Element;
};

const setActiveColor = (active: boolean) => (active ? COLOR_BRAND_BLUE_40 : COLOR_NEUTRAL_50);

export const itemsList: OrderByItem[] = [
  {
    slug: 'approve',
    label: 'Aprovação',
    showOnBenefit: 'all',
    icon: (active) => <IconBarChart size="small" rawColor={setActiveColor(active)} />,
  },
  {
    slug: 'miles',
    label: 'Pontos',
    showOnBenefit: 'miles',
    icon: (active) => <IconPlane size="small" rawColor={setActiveColor(active)} />,
  },
  {
    slug: 'cashback',
    label: 'Cashback',
    showOnBenefit: 'cashback',
    icon: (active) => <IconMoney size="small" rawColor={setActiveColor(active)} />,
  },
  {
    slug: 'benefits',
    label: 'Benefícios',
    showOnBenefit: 'both',
    icon: (active) => <IconAward size="small" rawColor={setActiveColor(active)} />,
  },
];
